<div class="row">
    <div class="col-md-1 prevBtn">
        <a mat-fab  [disabled]="auditDateCtrl.value != '' && auditDateCtrl.value != null && auditDateCtrl.value <= auditDateMinDate" 
            matTooltip="previous day" color="basic" class="fab-main" (click)="goBackDay()"><mat-icon
                class="mat-18">arrow_back_ios</mat-icon></a>
    </div>
    <div class="col-md-3">

        <so-date-picker [formCtrl]="auditDateCtrl" label="Status at Prior Date" placeHolder="enter prior date (mm/dd/yyyy)"
            [minDate]="auditDateMinDate" [maxDate]="auditDateMaxDate"
            tooltip="Enter or select a date in the past to show the project status at the end of that date. Clear the control to return to the current status."
            errormessage="Invalid Date. Dates are restricted to range of changes."
            (changeEvent)="dateSelectionChange()"></so-date-picker>
    </div>
    <div class="col-md-1 nextBtn" >
        <a mat-fab [disabled]="auditDateCtrl.value == '' || auditDateCtrl.value == null || auditDateCtrl.value >= auditDateMaxDate" matTooltip="next day" color="basic" class="fab-main" (click)="goForwardDay()"><mat-icon
                class="mat-18">arrow_forward_ios</mat-icon>
                
        </a>
    </div>

</div>

<div class="btnGoBack">
    <button (click)="goBack()" id="btnGoBack" type="button" mat-raised-button>
        <mat-icon class="mat-18 ">arrow_back_ios</mat-icon> Go Back </button>
</div>
<div class="btnSavePDF">
    <button (click)="generatePDF()" id="btnSavePDF" class="" type="button" mat-raised-button>
        <mat-icon class="mat-18 ">picture_as_pdf</mat-icon> Save PDF </button>
</div>

<mat-card class="card-container" id="statusReport" [ngClass]="{'iframeclass':isInIframe}">

    <mat-card-content class="card-container" (click)="goBack()">
        <div class="row outline">
            <div class="col-6 box-header">
                <h1 class="mat-h2 app-h2 left-text">{{projectHeader}}</h1>

                <div class="mat-h2 app-h2 app-lead left-text">Lead: {{projectManager | azureName}} </div>
                <!--h2 class="mat-h2 left-text"> Lead: {{projectManager | azureName}} </h2-->
            </div>
            <div class="col-6 box-header">
                <div class="row">
                    <div class="col-6">
                        <h2 class="app-h2 right-h2">Current Period: </h2>
                    </div>
                    <div class="col-6">
                        <div class="mat-h2 app-h2 right-title {{workRequest.projectStatus}}">{{
                            decodeStatus(workRequest.projectStatus!, false)}}</div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <h2 class="app-h2 right-h2">Previous Period: </h2>
                    </div>
                    <div class="col-6">
                        <div class="mat-h2 app-h2 right-title {{workRequest.previousProjectStatus}}">{{
                            decodeStatus(workRequest.previousProjectStatus!, false)}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row outline">
            <div class="col-6 rt-fields">
                <h3 class="app-h3-section left-text">Objective(s)</h3>
                <div class="long-text" [innerHTML]="workRequest.objectives || 'No objectives entered' | SafeHtml"></div>

                <h3 class="app-h3-section left-text">Key Accomplishments </h3>
                <div class="long-text"
                    [innerHTML]="workRequest.keyAccomplishments || 'No key accomplishments entered' | SafeHtml"></div>

                <h3 class="app-h3-section left-text">Upcoming Activities </h3>
                <div class="long-text"
                    [innerHTML]="workRequest.upcomingActivities || 'No upcoming activities entered' | SafeHtml"></div>

                <h3 class="app-h3-section left-text">Decision Taken / Required </h3>
                <div class="long-text" [innerHTML]="workRequest.decisions  || 'No decisions entered' | SafeHtml"></div>

                <h3 class="app-h3-section left-text">Risks </h3>
                <div class="long-text" [innerHTML]="workRequest.risks || 'No risks identified' | SafeHtml"></div>

                <h3 class="app-h3-section left-text">Committed Project Resources </h3>
                <div class="long-text" [innerHTML]="getResources() | azureName | SafeHtml"></div>

            </div>
            <div class="col-6">
                <div class="row">
                    <div class="col-4 app-h3">Key Milestone</div>
                    <div class="col-3 app-h3">Original Due Date</div>
                    <div class="col-3 app-h3">Revised Due Date</div>
                    <div class="col-2 app-h3">Status</div>
                </div>
                <div *ngFor="let ms of workRequest.pmMilestones" class="milestones-div">
                    <div class="row outline">
                        <div class="col-4 left-text">{{ms.description}}</div>
                        <div class="col-3 left-text">{{ms.date | date}}</div>
                        <div class="col-3 left-text">{{ms.revisionDate | date}}</div>
                        <div class="col-2 grid-status {{ms.status}}">{{decodeStatus(ms.status!, true)}}</div>
                    </div>
                </div>
                <div class="long-text" style="margin-top: 15px;"
                    *ngIf="!workRequest.pmMilestones || workRequest.pmMilestones.length === 0">No project milestones
                    entered.</div>
                <div *ngIf="workRequest.pmMilestones  && workRequest.pmMilestones!.length > 0">
                    <p>
                        Note: Timelines may be notional. They may be adjusted.
                    </p>
                    <p>
                        <b>Legend |
                            <span class="on-plan legend">&nbsp;G&nbsp;</span> On Plan
                            <span class="behind-plan legend">&nbsp;Y&nbsp;</span> Behind Plan
                            <span class="significantly-behind-plan legend ">&nbsp;R&nbsp;</span> Significantly Behind
                            Plan
                            <span class="completed legend">&nbsp;C&nbsp;</span> Completed
                            <br>
                            <span class="not-started legend">&nbsp;N&nbsp;</span> Not Started
                            <span class="pre-planning legend">&nbsp;P&nbsp;</span> Pre-planning / Pilot
                        </b>
                    </p>
                </div>
            </div>
        </div>
    </mat-card-content>
</mat-card>